"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDefaultOptions = void 0;
const osr_window_type_1 = require("../enums/osr_window_type");
const window_type_1 = require("../enums/window_type");
// -----------------------------------------------------------------------------
/** @internal */
function applyDefaultOptions(options, windowType) {
    if (!options) {
        return;
    }
    if (options.grabFocusOnDesktop === undefined) {
        options.grabFocusOnDesktop = false;
    }
    if (options.popupBlocker === undefined) {
        options.popupBlocker = true;
    }
    if (options.blockTopWindowNavigation === undefined) {
        options.blockTopWindowNavigation = true;
    }
    if (options.autoDpi === undefined) {
        options.autoDpi = true;
    }
    if (windowType === window_type_1.WindowType.Desktop) {
        _applyDefaultOptionsDesktop(options);
    }
    if (windowType === window_type_1.WindowType.Offscreen) {
        _applyDefaultOptionsOffscreen(options);
    }
}
exports.applyDefaultOptions = applyDefaultOptions;
// -----------------------------------------------------------------------------
function _applyDefaultOptionsDesktop(options) {
    if (options.showInTaskBar === undefined) {
        options.showInTaskBar = true;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    options.desktopWindow = true;
}
// -----------------------------------------------------------------------------
function _applyDefaultOptionsOffscreen(options) {
    if (options.type === undefined) {
        options.type = osr_window_type_1.OSRType.Default;
    }
    if (options.transparent === undefined) {
        options.transparent = true;
    }
    if (options.autoZoom === undefined) {
        options.autoZoom = true;
    }
    if (options.type === osr_window_type_1.OSRType.InGameOnly) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        options.InGameOnly = true;
    }
    if (options.type === osr_window_type_1.OSRType.DesktopOnly) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        options.DesktopOnly = true;
    }
}
//# sourceMappingURL=default_options.js.map